import { LINKEDIN, MAX_BYTES_STORAGE } from "../utils/constants";
import types from "../types";

const initialState = {
  geoIP: {},
  integrations: {},
  totalMetrics: {},
  businessName: "",
  users: {},
  isLoading: true,
  hideDelayMetricsAlert: false,
  storage: {
    usedBytes: 0,
    updatedDateTime: null,
    maxBytes: MAX_BYTES_STORAGE,
  },
};
export const userReducer = (state = initialState, action) => {
  let integrations;
  switch (action.type) {
    case types.GET_TOTAL_METRICS_CAMPAIGNS:
      return {
        ...state,
        totalMetrics: action.payload,
      };
    case types.GET_USER_IP:
      return {
        ...state,
        geoIP: action.payload,
      };
    case types.GET_FACEBOOK_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          facebook: {
            ...state.integrations.facebook,
            [action.payload.id]: action.payload,
          },
        },
        isLoading: false,
      };
    case types.REVOKE_FACEBOOK_INTEGRATION:
      integrations = { ...state.integrations?.facebook };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          facebook: integrations,
        },
        isLoading: false,
      };
    case types.GET_GOOGLE_ADS_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          google: {
            ...state.integrations.google,
            [action.payload.id]: action.payload,
          },
        },
        isLoading: false,
      };
    case types.REVOKE_GOOGLE_ADS_INTEGRATION:
      integrations = { ...state.integrations?.google };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          google: integrations,
        },
        isLoading: false,
      };
    case types.GET_GOOGLE_DRIVE_INTEGRATION:
      console.log(
        "[Google Drive Integration] Payload guardado en reducer:",
        action.payload
      );
      return {
        ...state,
        integrations: {
          ...state.integrations,
          googleDrive: {
            ...state.integrations.googleDrive,
            [action.payload.id]: action.payload,
          },
        },
        isLoading: false,
      };
    case types.REVOKE_GOOGLE_DRIVE_INTEGRATION:
      integrations = { ...state.integrations?.googleDrive };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          googleDrive: integrations,
        },
        isLoading: false,
      };
    case types.GET_LINKEDIN_ADS_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          [LINKEDIN]: {
            ...state.integrations?.[LINKEDIN],
            [action.payload.id]: action.payload,
          },
        },
        isLoading: false,
      };
    case types.REVOKE_LINKEDIN_ADS_INTEGRATION:
      integrations = { ...state.integrations?.[LINKEDIN] };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          [LINKEDIN]: integrations,
        },
        isLoading: false,
      };
    case types.GET_YOUTUBE_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          youtube: {
            ...state.integrations?.youtube,
            [action.payload.id]: action.payload,
          },
        },
        isLoading: false,
      };
    case types.REVOKE_YOUTUBE_INTEGRATION:
      integrations = { ...state.integrations?.youtube };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          youtube: integrations,
        },
        isLoading: false,
      };
    case types.GET_BUSINESS_NAME:
      return {
        ...state,
        businessName: action.payload,
      };
    case types.GET_ADS_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case types.MANAGE_USER:
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.userID]: action.payload.data,
        },
      };
    case types.DELETE_USER:
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload]: {
            ...state.users[action.payload],
            isDeleted: true,
          },
        },
      };
    case types.GET_CANVA_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          canva: {
            ...(state.integrations?.canva || {}),
            [action.payload.id]: action.payload,
          },
          isLoading: false,
        },
      };
    case types.REVOKE_CANVA_INTEGRATION: {
      const integrationId = action.payload?.id;
      const canvaData = state.integrations?.canva;
      if (!integrationId) {
        return {
          ...state,
          integrations: { ...state.integrations, canva: undefined },
          isLoading: false,
        };
      }
      if (typeof canvaData !== "object" || canvaData === null) {
        return { ...state, isLoading: false };
      }
      if (integrationId in canvaData) {
        const canvaIntegrations = { ...canvaData };
        delete canvaIntegrations[integrationId];
        return {
          ...state,
          integrations: {
            ...state.integrations,
            canva: canvaIntegrations,
          },
          isLoading: false,
        };
      }
      if (canvaData.id === integrationId) {
        return {
          ...state,
          integrations: { ...state.integrations, canva: undefined },
          isLoading: false,
        };
      }
      return { ...state, isLoading: false };
    }
    case types.GET_TIKTOK_BUSINESS_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          tiktokBusiness: {
            ...state.integrations.tiktokBusiness,
            [action.payload.id]: action.payload,
          },
        },
      };
    case types.REVOKE_TIKTOK_BUSINESS_INTEGRATION:
      integrations = { ...state.integrations?.tiktokBusiness };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          tiktokBusiness: integrations,
        },
        isLoading: false,
      };
    case types.GET_TIKTOK_INTEGRATION:
      return {
        ...state,
        integrations: {
          ...state.integrations,
          tiktok: {
            ...state.integrations.tiktok,
            [action.payload.id]: action.payload,
          },
        },
      };
    case types.REVOKE_TIKTOK_INTEGRATION:
      integrations = { ...state.integrations?.tiktok };

      delete integrations[action.payload.id];
      return {
        ...state,
        integrations: {
          ...state.integrations,
          tiktok: integrations,
        },
        isLoading: false,
      };
    case types.GET_INTEGRATIONS:
      if (action.payload?.googleDrive) {
        console.log(
          "[Google Drive Integration] Datos cargados desde Firebase:",
          action.payload.googleDrive
        );
      }
      return {
        ...state,
        integrations: action.payload,
        isLoading: false,
      };
    case types.SET_FACEBOOK_INTEGRATION_BUSINESS_ACCOUNTS: {
      const { integrationID, businessAccounts } = action.payload;
      const fbRoot = state.integrations?.facebook || {};
      const current = fbRoot[integrationID];
      if (!current) {
        return state;
      }
      return {
        ...state,
        integrations: {
          ...state.integrations,
          facebook: {
            ...fbRoot,
            [integrationID]: {
              ...current,
              businessAccounts,
            },
          },
        },
      };
    }
    case types.SET_FACEBOOK_INTEGRATION_PAGES: {
      const { integrationID, pages } = action.payload;
      const fbRoot = state.integrations?.facebook || {};
      const current = fbRoot[integrationID];
      if (!current) {
        return state;
      }
      return {
        ...state,
        integrations: {
          ...state.integrations,
          facebook: {
            ...fbRoot,
            [integrationID]: {
              ...current,
              pages,
            },
          },
        },
      };
    }
    case types.SET_LINKEDIN_INTEGRATION_ADVERTISERS: {
      const { integrationID, advertisers } = action.payload;
      const linkedInRoot = state.integrations?.[LINKEDIN] || {};
      const current = linkedInRoot[integrationID];
      if (!current) {
        return state;
      }
      return {
        ...state,
        integrations: {
          ...state.integrations,
          [LINKEDIN]: {
            ...linkedInRoot,
            [integrationID]: {
              ...current,
              advertisers,
            },
          },
        },
      };
    }
    case types.SET_LINKEDIN_INTEGRATION_PAGES: {
      const { integrationID, pages } = action.payload;
      const linkedInRoot = state.integrations?.[LINKEDIN] || {};
      const current = linkedInRoot[integrationID];
      if (!current) {
        return state;
      }
      return {
        ...state,
        integrations: {
          ...state.integrations,
          [LINKEDIN]: {
            ...linkedInRoot,
            [integrationID]: {
              ...current,
              pages,
            },
          },
        },
      };
    }
    case types.GET_LAST_SELECTED_INTEGRATION_DATA:
      return {
        ...state,
        lastSelectedIntegrationData: action.payload,
        isLoading: false,
      };
    case types.SET_LAST_SELECTED_INTEGRATION_DATA_BY_PLATFORM:
      return {
        ...state,
        lastSelectedIntegrationData: {
          ...state.lastSelectedIntegrationData,
          [action.payload.platform]: action.payload.data,
        },
      };
    case types.GET_USER_HIDE_METRICS_ALERT:
      return {
        ...state,
        hideDelayMetricsAlert: action.payload,
      };
    case types.SET_USER_HIDE_METRICS_ALERT:
      return {
        ...state,
        hideDelayMetricsAlert: action.payload,
      };
    case types.SET_USER_STORAGE:
      return {
        ...state,
        storage: action.payload || initialState.storage,
      };
    case types.GLOBAL_RESET_STATE:
      return { ...initialState, geoIP: state.geoIP };
    default:
      return state;
  }
};
